module.exports = __webpack_public_path__ + "static/media/lykke09.303579d0.jpg";